export default {
    data: function () {
        return {
            MSGRAPH: process.env.MIX_MSGRAPH.toLowerCase().trim() === "true",
        }
    },
}